import { createLucideIcon } from "lucide-react";

/** O lucide não tem batata frita; ícone no mesmo traço (24px, stroke 2). */
export const FriesIcon = createLucideIcon("fries", [
  ["path", { d: "M5 11h14l-1.6 9.6a1.5 1.5 0 0 1-1.5 1.4H8.1a1.5 1.5 0 0 1-1.5-1.4z", key: "box" }],
  ["path", { d: "M8 11V4.5", key: "f1" }],
  ["path", { d: "M11 11V3", key: "f2" }],
  ["path", { d: "M14 11V4", key: "f3" }],
  ["path", { d: "M17 11V5.5", key: "f4" }],
  ["path", { d: "M8.5 15a4 4 0 0 0 7 0", key: "smile" }],
]);
